// Command-palette style global search over clients.
import { useState, useEffect, useRef } from "react";
import { cl, getCurrencySymbol } from "../lib/format";
import { themeTokens } from "../lib/theme";
import { ClientDetailModal } from "../modals/client";

export const GlobalSearch=({clients,theme,onClose,userId,profile})=>{
  const [q,setQ]=useState("");
  const [sel,setSel]=useState(null);
  const inputRef=useRef(null);
  const {isDark,tc,mc,bc}=themeTokens(theme);
  const cb=isDark?"#1e293b":"#fff";

  useEffect(()=>{setTimeout(()=>inputRef.current?.focus(),100);},[]);

  const results=q.trim().length<1?[]:clients.filter(c=>
    c.name?.toLowerCase().includes(q.toLowerCase())||
    c.mobile?.includes(q)||
    c.serviceAvailed?.toLowerCase().includes(q.toLowerCase())
  ).slice(0,8);

  const statusColor=(c)=>{
    const hasPackage=c.package?.type&&c.package.type!=="none";
    if(hasPackage&&c.package.type==="custom"&&(c.classesRemaining===0||c.classesRemaining===undefined))return{bg:"#fef2f2",text:"#dc2626",label:"Expired"};
    if(hasPackage&&c.classesRemaining<=2&&c.classesRemaining>0)return{bg:"#fffbeb",text:"#d97706",label:`${c.classesRemaining} left`};
    if(!hasPackage||c.package?.type==="monthly"||c.package?.type==="quarterly"||c.package?.type==="yearly")return{bg:"#f0fdf4",text:"#16a34a",label:"Active"};
    return{bg:"#f0fdf4",text:"#16a34a",label:"Active"};
  };

  if(sel)return(
    <div className="fixed inset-0 z-50" style={{background:isDark?"#0f172a":"#fff"}}>
      <div className="flex items-center gap-3 px-4 py-3 border-b" style={{borderColor:bc}}>
        <button onClick={()=>setSel(null)} className="p-2 rounded-xl" style={{color:mc}}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <span className="font-semibold text-sm" style={{color:tc}}>{sel.name}</span>
        <button onClick={onClose} className="ml-auto p-2 rounded-xl" style={{color:mc}}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>
      <div className="p-4 overflow-y-auto" style={{maxHeight:"calc(100vh - 60px)"}}>
        <ClientDetailModal c={sel} onClose={()=>setSel(null)} theme={theme} userId={userId} currency={getCurrencySymbol(profile)||"₹"} bare/>
      </div>
    </div>
  );

  return(
    <div className="fixed inset-0 z-50" style={{background:isDark?"rgba(0,0,0,0.9)":"rgba(0,0,0,0.5)",backdropFilter:"blur(4px)"}}>
      <div className="h-full flex flex-col max-w-lg mx-auto">
        {/* Search bar */}
        <div className="flex items-center gap-3 px-4 py-3 m-4 mb-0 rounded-2xl shadow-xl" style={{background:cb}}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={mc} strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          <input ref={inputRef} className="flex-1 text-sm bg-transparent outline-none"
            style={{color:tc}} placeholder="Search clients by name, mobile, service..."
            value={q} onChange={e=>setQ(e.target.value)}/>
          <button onClick={onClose} className="text-xs font-semibold px-3 py-1.5 rounded-xl" style={{background:bc,color:mc}}>Cancel</button>
        </div>

        {/* Results */}
        <div className="flex-1 overflow-y-auto p-4 space-y-2">
          {q.trim().length===0&&(
            <div className="text-center py-16">
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4" style={{background:isDark?"#1e293b":"#f3f4f6"}}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={mc} strokeWidth="1.5"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              </div>
              <p className="text-sm font-semibold mb-1" style={{color:tc}}>Search your clients</p>
              <p className="text-xs" style={{color:isDark?mc:"#4b5563"}}>Name, mobile number or service</p>
            </div>
          )}
          {q.trim().length>0&&results.length===0&&(
            <div className="text-center py-16">
              <p className="text-sm font-semibold mb-1" style={{color:tc}}>No {cl(profile,2).toLowerCase()} found</p>
              <p className="text-xs" style={{color:mc}}>Try a different name or number</p>
            </div>
          )}
          {results.map(c=>{
            const s=statusColor(c);
            return(
              <button key={c.id} onClick={()=>setSel(c)}
                className="w-full flex items-center gap-3 p-4 rounded-2xl text-left transition-all"
                style={{background:cb}}>
                <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 font-bold text-white text-sm"
                  style={{background:theme?.primary||"#0f766e"}}>
                  {c.name?.charAt(0).toUpperCase()}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-sm truncate" style={{color:tc}}>{c.name}</p>
                  <p className="text-xs truncate" style={{color:mc}}>{c.serviceAvailed||"No service"}{c.mobile?` · ${c.mobile}`:""}</p>
                </div>
                <span className="text-xs font-semibold px-2 py-1 rounded-lg flex-shrink-0"
                  style={{background:s.bg,color:s.text}}>{s.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
